// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductLoyaltyBlock_container__YBxKN"};